import React, { useEffect } from 'react';
import SplashTables from '../../assets/splashTables.png'
import { Container, Button, Grid, Typography, CircularProgress, Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Launch from '@material-ui/icons/Launch';


import CardActionArea from '@material-ui/core/CardActionArea';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ImageOutlined from '@material-ui/icons/ImageOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import ListAltOutlined from '@material-ui/icons/ListAltOutlined';
import BuildOutlined from '@material-ui/icons/BuildOutlined';
import VerifiedUserOutlined from '@material-ui/icons/VerifiedUserOutlined';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import { getFromAPI } from '../helpers/sqlApiCalls';
import ExportJsonExcel from 'js-export-excel'


const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 180,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: theme.spacing(2),
    },
    bgDg: {
        width: '100%',
        position: 'absolute',
        left: 0,
        height: 200,
        top: 64
    },
    textWhite1: {
        color: "#fff",
        fontSize: 25, fontWeight: 500
    },
    textWhite2: {
        color: "#fff",
        fontSize: 15, fontWeight: 300
    }, bgimg: {
        width: '100%',
        position: 'absolute',
        left: 0,
        minWidth: '100%',
        top: 64,
        height: 200
    },
    bgimg2: {
        // background: "rgb(0,0,0)",
        // background: "linear-gradient(180deg, rgba(0,0,0,0.7113620448179272) 62%, rgba(0,0,0,0) 100%)",
        width: '100%',
        minWidth: '100%',
        position: 'absolute',
        left: 0,
        top: 64,
        height: 200
    },
    spinner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // height: '100vh'
    },
}));




function PriceList(props) {

    const classes = useStyles();
    const [pricesList, setPricesList] = React.useState(null)
    const [articles, setArticles] = React.useState(null)
    const [loading, setLoading] = React.useState(true)
    const clData = JSON.parse(localStorage.clData)

    let option = {};
    option.fileName = 'LISTA DE PRECIOS';
    option.datas = []
    const toExcel = new ExportJsonExcel(option); //new

    useEffect(() => {
        const getPriceListArticles = async () => {
            // const [plClient, articlesList] = await Promise.all([getFromAPI("PriceList", `k=${clData.pl}`), await getFromAPI("Articles")])
            // setPricesList(plClient)
            // setArticles(articlesList)
            // setLoading(false)
            if (clData && clData.pl) {
                const [plClient, articlesList] = await Promise.all([getFromAPI("PriceList", `k=${clData.pl}`), await getFromAPI("Articles")])
                setPricesList(plClient)
                setArticles(articlesList)
            }
            setLoading(false)
        }
        getPriceListArticles()
    }, [])

    // useEffect(() => {
    //     if(pricesList && pricesList.length > 0){
    //         setLoading(false)
    //     }
    // }, [pricesList])


    const importPriceList = (priceList) => {
        const response = Object.values(priceList.a)
        const articulos = []
        response.map(articulo => {
            let articleFind = articles.find(e => e.k == articulo.k)
            if (articleFind) {
                articulos.push({
                    A: articulo.rk ? articulo.rk : "",
                    B: articulo.k ? articulo.k : "",
                    C: articleFind.n ? articleFind.n : "",
                    D: articleFind.um[articleFind.dum].k ? articleFind.um[articleFind.dum].k : "",
                    E: articleFind.um[articleFind.dum].n ? articleFind.um[articleFind.dum].n : "",
                    F: articulo.fp ? articulo.fp.a : "",

                })
            }
        })
        option.datas.push({
            sheetHeader: ['SKU', 'COD. INTERNO', 'NOMBRE', 'COD. UNIDAD MEDIDA', 'NOMBRE UNIDAD MEDIDA', 'PRECIO'], // encabezado de la primera fila
            sheetData: [...articulos],// FILAS
            sheetName: `${priceList.n}`, // nombre de la hoja
            columnWidths: [5, 8, 14, 5, 10, 5, 10]
        })
        toExcel.saveExcel()
    }



    return (
        <div>
            <div style={{ position: "absolute", top: 115, left: 0 }}>
                <img src={SplashTables} style={{ height: 115, width: '100%' }} alt="Logo" />
            </div>
            <Container>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                    <div style={{ zIndex: 1 }}>
                        <p color="#000000" style={{ fontSize: 28, marginTop: 10, marginBottom: 10 }}>Información</p>
                    </div>

                </div>
            </Container>
            {loading ?
                <Container style={{ alignItems: "center" }}>
                    <CircularProgress style={{ marginTop: 10, marginBottom: 10 }} color="secondary" />
                </Container>
                :
                <Container maxWidth="lg" style={{ paddingTop: 10 }} >
                    <Typography style={{ fontSize: 18, fontWeight: 500, paddingBottom: 15 }}>
                        Listas de precios
                    </Typography>
                    <Grid container className={classes.root} spacing={2}>
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                {
                                    pricesList && pricesList.length > 0 ?
                                        pricesList.map((row, index) => (
                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                <Card className={classes.root}>
                                                    <CardActionArea onClick={() => { importPriceList(row) }} >
                                                        <CardContent>
                                                            <AssignmentOutlinedIcon style={{ fontSize: 40, color: "#0f5591" }} ></AssignmentOutlinedIcon>
                                                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                                                &nbsp;
                                                            </Typography>
                                                            <div style={{ width: '100%', position: "relative" }}>
                                                                <Typography style={{ fontSize: 20 }}>
                                                                    {row.n}
                                                                </Typography>
                                                                <Tooltip title="Descargar">
                                                                    <IconButton style={{ color: "#0f5591", position: "absolute", right: 10, top: -5 }} edge="end" aria-label="comments">
                                                                        <Launch />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div>
                                                        </CardContent>
                                                    </CardActionArea>
                                                </Card>
                                            </Grid>
                                        ))
                                        :
                                        <div style={{ flex: 1, margin: '0.5rem' }}>

                                            <div className={classes.spinner}>
                                                <p>No hay listas de precios asignadas</p>
                                            </div>

                                        </div>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                        &nbsp;
                    </Typography>
                </Container>
            }
        </div>
    )
}
export default PriceList